import { Flat } from "./flat.js";

export class DecorateYourLivingroom extends Flat {
    static info = {
        key: "decorate-your-living-room",
        name: "Decorate Your House",
        description: "Now that the house is clean, it’s time to decorate to bring in good fortune and prosperity in the New Year! Follow Pei Pei’s clues to figure out where each decoration should go.",
        logo: {x: 310, y: 520},
        won: false
    }
    constructor(key, level, options){
        super(key, level, {...options, x: 2200, y: 1100, holder: true})
        this._pickables = {
            group: null,
            list: [
                {
                    name: "dh-flowers",
                    destinations: [ { name: "small-table", x: 1172, y: 340}, { name: "bedroom-drawer", x: 2818, y: 153 }],
                    peipei: {
                        take: "Let's start the game! Place the decoration items in the best place. Our first item is: Flowers. Flowers are a sign of new beginnings. Find a place with plenty of sunlight."
                    }
                },
                {
                    name: "dh-door-hangings",
                    destinations: [ { name: "door", x: 1640, y: 215 } ],
                    peipei: {
                        take: "Nice Job! The next item is: Couplets. Hint: It is often made of wood, although it is not a chair. Sometimes has a lock, but is not made of hair."
                    }
                },
                {
                    name: "dh-paper-cut-outs",
                    destinations: [ { name: "window-1", x: 1387, y: 337 }, { name: "window-2", x: 2044, y: 337 }, { name: "window-3", x: 3222, y: 217 } ],
                    peipei: {
                        take: "Perfect! The next item is: Paper cut outs. Hint: This might be open when it’s hot, and be closed if it has rained"
                    }
                },
                {
                    name: "dh-oranges",
                    destinations: [ { name: "coffee-table", x: 1595, y: 1013 }, { name: "middle-counter", x: 1860, y: 2007 }, { name: "dining-table", x: 634, y: 1719 } ],
                    peipei: {
                        take: "Great job! The next item is: Oranges. Oranges are a sign of good fortune. Find a place where family and guests could eat them."
                    }
                },
            ],
            current: 0
        }
        this._totalStars = null
    }
    preload() {
        super.preload()
        this._pickables.list.forEach(i => this.load.image(i.name, `assets/decorate-your-living-room/${i.name}.png`))
    }
    create() {
        super.create()
        this._pickables.group = this.physics.add.staticGroup()
        this._pickables.list.forEach(d => this._pickables.group.create(0, 0, d.name).setOrigin(0, 0).setVisible(0))
        this.physics.add.collider(this.bob, [this._furniture])
        this._totalStars = this._pickables.list.length * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._totalStars}`)
        this._holder.take(this._pickables.group.getChildren()[0])
    }
    onSpace(){
        if (!this._holder.holding() || this._holder.busy) return
        const overlaps = this._furniture.children.entries.filter(f => this.physics.overlapRect(f.x, f.y, f.width, f.height-20, true, false).length !== 0)
        if (overlaps.length !== 1) return
        const f = overlaps[0]
        let target = this._pickables.list[this._pickables.current]
        let decorPosition = target.destinations.filter( d => d.name === f.texture.key )
        if (decorPosition.length === 0) {
            this.peiPeiSay("Oops… It does not belong here")
            this.sound.play("wrong")
            return
        }
        this._holder.drop(decorPosition[0])
        let score = this.board.score.text
        this.board.score.setText(`${parseInt(score) + 5}/${this._totalStars}`)
        if (this.bob) this.say("Nice job! You earned 5 stars!")
        this.sound.play("right");
        this._pickables.current++
        if (this._pickables.current !== this._pickables.list.length) {
            this._holder.take(this._pickables.group.getChildren()[0])
            return
        }
        this.win(this.board.score.text)
        this.peiPeiSay("Mission Accomplished!")
    }
}